import { BaseListChatMessageHistory } from "@langchain/core/chat_history";
import {
  BaseMessage,
  mapStoredMessagesToChatMessages,
  mapChatMessagesToStoredMessages,
  StoredMessage,
} from "@langchain/core/messages";
import { IMemoryClientOptions, MemoryClient } from "@cloudbase/agent-agents";

export class TDAIChatHistory extends BaseListChatMessageHistory {
  lc_namespace = ["langchain", "stores", "message", "tdai"];

  public client: MemoryClient;

  private sessionId: string;

  constructor(options: IMemoryClientOptions & { sessionId: string }) {
    super();
    const { sessionId, ...clientOptions } = options;
    this.client = new MemoryClient({
      ...clientOptions,
    });
    this.sessionId = options.sessionId;
  }

  async getMessages(): Promise<BaseMessage[]> {
    const { events = [] } = await this.client.queryEvents({
      sessionId: this.sessionId,
    });

    return mapStoredMessagesToChatMessages(
      events.map((event) => {
        return {
          type: event.type,
          data: event.data,
        };
      })
    );
  }

  /**
   * Method to add a new message to the Firestore collection. The message is
   * passed as a BaseMessage object.
   * @param message The message to be added as a BaseMessage object.
   */
  public async addMessage(message: BaseMessage) {
    const messages = mapChatMessagesToStoredMessages([message]);
    await this.appendMessage(messages[0]);
  }

  private async appendMessage(message: StoredMessage): Promise<void> {
    await this.client.appendEvent({
      sessionId: this.sessionId,
      messages: message,
    });
  }

  /**
   * Method to delete all messages from the Firestore collection associated
   * with the current session.
   */
  public async clear(): Promise<void> {
    const eventIds = await this.client
      .queryEvents({
        sessionId: this.sessionId,
      })
      .then(({ events = [] }) => events.map((event: any) => event.event_id));

    await Promise.all(
      eventIds.map((id: string) => {
        return this.client.deleteEvent({
          sessionId: this.sessionId,
          eventId: id,
        });
      })
    );

    await this.client.deleteSession({
      sessionId: this.sessionId,
    });
  }
}

